import { hedgeStatus } from 'shared/helpers/constants/hedges/hedgeStatus';

const allowedStatuses = [hedgeStatus.open, hedgeStatus.cancelled];

const deleteHedgeAccess = ({ access }, { status, hasAssociatedDeliveries }) =>
  access.hedges.delete && allowedStatuses.includes(status) && !hasAssociatedDeliveries;

export { deleteHedgeAccess };
